(function() {
    const archiveEl = document.querySelector('.jsMatTrainArchive');
    let archiveGrid = null;
    // let searchTimeout = null;
    // let searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            const typeSelect = new SeSelect(typeFilterEl, 'type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(newOptions => {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const type2FilterEl = archiveEl.querySelector('.jsType2Filter');
        if (type2FilterEl) {
            const type2Select = new SeSelect(type2FilterEl, 'offer-type');
            type2Select.setActiveOptions(activeType2Types);

            type2Select.addChangeEventListener(newOptions => {
                activeType2Types = Object.keys(newOptions);
                updateGrid();
            });
        }

        // const languageFilterEl = archiveEl.querySelector('.jsLanguageFilter');
        // if (languageFilterEl) {
        //     const type2Select = new SeSelect(languageFilterEl, 'language');
        //     type2Select.setActiveOptions(activeLanguages);

        //     type2Select.addChangeEventListener(newOptions => {
        //         activeLanguages = Object.keys(newOptions);
        //         updateGrid();
        //     });
        // }

        // const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        // if (searchFormEl) {
        //     const searchInputEl = searchFormEl.querySelector('input');

        //     searchFormEl.addEventListener('submit', e => {
        //         e.preventDefault();
        //         userDidSearch(searchInputEl.value);
        //     });

        //     searchInputEl.addEventListener('keyup', e => {
        //         e.preventDefault();
        //         userDidSearch(searchInputEl.value);
        //     });
        // }
    }

    // function userDidSearch(query) {
    //     searchQuery = query;

    //     // Update the URL
    //     const url = new Url;

    //     if (searchQuery) url.query.search = searchQuery;
    //     else delete url.query.search;

    //     history.pushState(null, null, url.toString());

    //     // Set a timeout
    //     if (searchTimeout) clearTimeout(searchTimeout);
    //     searchTimeout = setTimeout(_ => updateGrid(), 500);
    // }

    function updateGrid() {
        const params = {
            action: 'get_mat_train_grid_html',
            activeTypes,
            activeThemes,
            activeType2Types,
            // activeLanguages,
            // searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
